























































import Vue from 'vue';
import { OrganisationService } from '@/services/OrganisationService';
import { OrganisationModel } from '@/types/models/organisation';
import { EntityType } from '@/types';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { FormFieldValidation, ModalHelpers } from '@/mixins';

export default Vue.extend({
  name: 'AddOrganisation',
  mixins: [FormFieldValidation, ModalHelpers],
  data() {
    return {
      organisation: {} as OrganisationModel,
      isLoading: false
    };
  },
  methods: {
    onSubmit(this: any) {
      this.isLoading = true;
      OrganisationService.createOrganisationAsync(this.organisation)
        .then((response) => {
          SnotifyConfiguration.showSuccess('Organisation added successfully.');
          this.setApplicationDirty(false);
          this.$router.push({ name: 'organisationManagement' });
        })
        .catch((error) => {
          this.$validator.errors.remove('serverValidationErrors');
          this.$validator.errors.add({
            field: 'serverValidationErrors',
            msg: error.notification
          });
          this.isLoading = false;
        });
    },
    async cancel(this: any) {
      this.$router.back();
    }
  },
  mounted() {
    OrganisationService.checkMaintenancePermissions();
  }
});
